// Mock data for Namoh Toolings website

export const categories = [
  {
    id: 'turning',
    name: 'Turning',
    description: 'Precision turning tools for superior surface finish and accuracy',
    image: 'https://images.unsplash.com/photo-1565008576549-57569a49371d?q=80&w=800',
    subcategories: [
      { id: 'external-turning', name: 'External Turning', productCount: 12 },
      { id: 'internal-turning', name: 'Internal Turning', productCount: 8 },
      { id: 'threading', name: 'Threading Tools', productCount: 15 },
      { id: 'boring', name: 'Boring Tools', productCount: 10 }
    ]
  },
  {
    id: 'milling',
    name: 'Milling',
    description: 'High-performance milling solutions for complex geometries',
    image: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?q=80&w=800',
    subcategories: [
      { id: 'face-milling', name: 'Face Milling', productCount: 10 },
      { id: 'end-milling', name: 'End Milling', productCount: 14 },
      { id: 'slot-milling', name: 'Slot Milling', productCount: 9 },
      { id: 'profile-milling', name: 'Profile Milling', productCount: 11 }
    ]
  },
  {
    id: 'drilling',
    name: 'Drilling',
    description: 'Reliable drilling tools for enhanced productivity',
    image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=800',
    subcategories: [
      { id: 'twist-drills', name: 'Twist Drills', productCount: 18 },
      { id: 'center-drills', name: 'Center Drills', productCount: 7 },
      { id: 'step-drills', name: 'Step Drills', productCount: 6 },
      { id: 'core-drills', name: 'Core Drills', productCount: 8 }
    ]
  },
  {
    id: 'grooving',
    name: 'Grooving',
    description: 'Specialized grooving tools for precise operations',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=800',
    subcategories: [
      { id: 'external-grooving', name: 'External Grooving', productCount: 9 },
      { id: 'internal-grooving', name: 'Internal Grooving', productCount: 7 },
      { id: 'face-grooving', name: 'Face Grooving', productCount: 5 },
      { id: 'profiling', name: 'Profiling Tools', productCount: 8 }
    ]
  },
  {
    id: 'parting',
    name: 'Parting',
    description: 'Efficient parting-off tools for clean separation',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=800',
    subcategories: [
      { id: 'standard-parting', name: 'Standard Parting', productCount: 10 },
      { id: 'deep-parting', name: 'Deep Parting', productCount: 6 },
      { id: 'recessing', name: 'Recessing Tools', productCount: 7 },
      { id: 'cut-off', name: 'Cut-off Tools', productCount: 9 }
    ]
  },
  {
    id: 'vci-packaging',
    name: 'VCI Packaging',
    description: 'Advanced corrosion prevention packaging solutions',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=800',
    subcategories: [
      { id: 'vci-films', name: 'VCI Films', productCount: 12 },
      { id: 'vci-bags', name: 'VCI Bags', productCount: 15 },
      { id: 'vci-papers', name: 'VCI Papers', productCount: 8 },
      { id: 'vci-emitters', name: 'VCI Emitters', productCount: 6 }
    ]
  }
];

export const products = [
  {
    id: 'prod-001',
    name: 'External Turning Insert CNMG',
    category: 'turning',
    subcategory: 'external-turning',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=CNMG+Insert',
    description: 'High-performance carbide insert for external turning operations with superior chip control.',
    specifications: {
      material: 'Carbide Grade TN7025',
      coating: 'PVD Multi-layer',
      geometry: 'CNMG 120408',
      cuttingSpeed: '200-350 m/min',
      feedRate: '0.2-0.5 mm/rev'
    },
    features: [
      'Excellent wear resistance',
      'Superior surface finish',
      'Stable cutting performance',
      'Suitable for steel and cast iron'
    ],
    applications: 'General turning, finishing operations, steel machining'
  },
  {
    id: 'prod-002',
    name: 'Face Milling Cutter D80',
    category: 'milling',
    subcategory: 'face-milling',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=Face+Mill+D80',
    description: 'Precision face milling cutter with indexable inserts for high material removal rates.',
    specifications: {
      diameter: '80mm',
      insertType: 'APMT 1604',
      numberOfTeeth: '8',
      maxDepth: '6mm',
      recommended: 'rpm: 1500-3000'
    },
    features: [
      'High rigidity design',
      'Low cutting forces',
      'Excellent chip evacuation',
      'Long tool life'
    ],
    applications: 'Face milling, shoulder milling, slot milling'
  },
  {
    id: 'prod-003',
    name: 'Solid Carbide Drill Ø10mm',
    category: 'drilling',
    subcategory: 'twist-drills',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=Carbide+Drill',
    description: 'Premium solid carbide drill bit for precision hole making in various materials.',
    specifications: {
      diameter: '10mm',
      length: '100mm',
      flutes: '2',
      material: 'Micrograin Carbide',
      coating: 'TiAlN'
    },
    features: [
      'Self-centering point',
      'High penetration rate',
      'Excellent hole quality',
      'Chip evacuation design'
    ],
    applications: 'Drilling steel, stainless steel, cast iron'
  },
  {
    id: 'prod-004',
    name: 'VCI Stretch Film Roll',
    category: 'vci-packaging',
    subcategory: 'vci-films',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=VCI+Film',
    description: 'High-performance VCI stretch film for superior corrosion protection of metal components during storage and transit.',
    specifications: {
      width: '500mm',
      thickness: '50 microns',
      length: '300 meters',
      vciType: 'Multi-metal protection',
      shelfLife: '24 months'
    },
    features: [
      'Protects ferrous and non-ferrous metals',
      'No oily residue',
      'Recyclable material',
      'UV stabilized for outdoor use'
    ],
    applications: 'Metal parts packaging, export shipments, warehouse storage'
  },
  {
    id: 'prod-005',
    name: 'VCI Polyethylene Bags',
    category: 'vci-packaging',
    subcategory: 'vci-bags',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=VCI+Bags',
    description: 'Premium VCI bags providing comprehensive corrosion protection for metal components and tools.',
    specifications: {
      material: 'LDPE with VCI additives',
      thickness: '100 microns',
      sizes: 'Multiple sizes available',
      protection: 'Up to 2 years',
      closure: 'Heat sealable'
    },
    features: [
      'Forms protective molecular layer',
      'Transparent for easy inspection',
      'No contamination of parts',
      'Cost-effective solution'
    ],
    applications: 'Tool storage, precision parts, automotive components'
  },
  {
    id: 'prod-006',
    name: 'VCI Paper Sheets',
    category: 'vci-packaging',
    subcategory: 'vci-papers',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=VCI+Paper',
    description: 'Eco-friendly VCI paper sheets for wrapping and interleaving metal parts.',
    specifications: {
      weight: '80 GSM',
      size: '1000mm x 1200mm',
      vciContent: '2-3%',
      protection: '12-24 months',
      material: '100% recyclable'
    },
    features: [
      'Biodegradable and recyclable',
      'Easy to wrap and fold',
      'No direct contact needed',
      'Clean and dry protection'
    ],
    applications: 'Wrapping metal parts, interleaving sheets, export packaging'
  }
];

export const companyInfo = {
  name: 'Namoh Toolings',
  tagline: 'WE LISTEN WE INNOVATE',
  about: 'Namoh Toolings is a leading manufacturer and supplier of precision cutting tools and tooling solutions. With years of expertise in the industry, we deliver innovative products that enhance productivity and manufacturing excellence.',
  mission: 'To provide world-class tooling solutions that empower manufacturers to achieve operational excellence and superior quality.',
  vision: 'To be the most trusted partner in precision tooling, known for innovation, quality, and customer-centric approach.',
  values: [
    'Quality Excellence',
    'Customer First',
    'Continuous Innovation',
    'Integrity & Trust'
  ],
  experience: '20+ Years',
  clients: '500+ Happy Clients',
  products: '20,000+ Products',
  professionals: '50+ Professionals'
};

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    company: 'Precision Engineering Ltd.',
    text: 'Namoh Toolings has been our trusted partner for over 5 years. Their quality and service are unmatched.',
    rating: 5
  },
  {
    id: 2,
    name: 'Amit Shah',
    company: 'Metro Manufacturing',
    text: 'The turning tools from Namoh have significantly improved our production efficiency and quality.',
    rating: 5
  },
  {
    id: 3,
    name: 'Priya Patel',
    company: 'Tech Components Inc.',
    text: 'Excellent product range and technical support. Highly recommended for all tooling needs.',
    rating: 5
  }
];

export const clients = [
  { id: 1, name: 'Tata Motors', industry: 'Automotive', initials: 'TM', color: '#1a3c6e' },
  { id: 2, name: 'Mahindra & Mahindra', industry: 'Automotive', initials: 'M&M', color: '#e4002b' },
  { id: 3, name: 'Larsen & Toubro', industry: 'Engineering', initials: 'L&T', color: '#003366' },
  { id: 4, name: 'Bharat Forge', industry: 'Manufacturing', initials: 'BF', color: '#0d4f8b' },
  { id: 5, name: 'Kirloskar', industry: 'Industrial', initials: 'KL', color: '#1b5e20' },
  { id: 6, name: 'Bosch', industry: 'Automotive', initials: 'B', color: '#e20015' },
  { id: 7, name: 'Godrej', industry: 'Engineering', initials: 'G', color: '#4a148c' },
  { id: 8, name: 'Thermax', industry: 'Industrial', initials: 'TX', color: '#c62828' },
  { id: 9, name: 'Crompton Greaves', industry: 'Manufacturing', initials: 'CG', color: '#00695c' },
  { id: 10, name: 'BHEL', industry: 'Heavy Engineering', initials: 'BH', color: '#1565c0' },
  { id: 11, name: 'Ashok Leyland', industry: 'Automotive', initials: 'AL', color: '#ad1457' },
  { id: 12, name: 'TVS Motor', industry: 'Automotive', initials: 'TVS', color: '#0277bd' }
];

export const newArrivals = [
  {
    id: 'new-001',
    name: 'Ceramic End Mill - Ultra Performance',
    category: 'milling',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=Ceramic+End+Mill',
    badge: 'NEW',
    description: 'Next-generation ceramic end mill for high-speed machining of hardened steels up to 65 HRC.',
    catalog_pdf: null
  },
  {
    id: 'new-002',
    name: 'Micro Boring Bar Set',
    category: 'turning',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=Micro+Boring+Bar',
    badge: 'NEW',
    description: 'Ultra-precision micro boring bars for internal operations as small as 3mm diameter.',
    catalog_pdf: null
  },
  {
    id: 'new-003',
    name: 'VCI Multi-Metal Emitter Capsules',
    category: 'vci-packaging',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=VCI+Emitters',
    badge: 'LATEST',
    description: 'Advanced VCI emitter capsules providing 360-degree corrosion protection in enclosed spaces.',
    catalog_pdf: null
  },
  {
    id: 'new-004',
    name: 'High-Feed Face Mill D50',
    category: 'milling',
    image: 'https://placehold.co/600x400/2E3A6F/ffffff?text=High-Feed+Mill',
    badge: 'NEW',
    description: 'Compact high-feed face mill with 6 cutting edges for maximum productivity.',
    catalog_pdf: null
  }
];

